import {
    caseListContainerClasses,
    listingCardContentClasses,
    caseListContainerWrapperClasses,
} from '../common/caseListClasses';

const ListingCardWrapper = ({
    children
}) => {
    return (
        <div className={caseListContainerWrapperClasses}>
            <div className={caseListContainerClasses}>
                <div className={listingCardContentClasses}>
                    {children}
                </div>
            </div>
        </div>

    );
};
export default ListingCardWrapper;
